import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Card from '@dashboard/components/Card';
import CardContent from '@dashboard/components/CardContent';
import CardHeader from '@dashboard/components/CardHeader';
import CardHeaderNav from '@dashboard/components/CardHeaderNav';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';

import SettingsBusinessProfile from './scenes/SettingsBusinessProfile';
import SettingsCustomerPortal from './scenes/SettingsCustomerPortal';
import SettingsDomains from './scenes/SettingsDomains';
import SettingsEmail from './scenes/SettingsEmail';
import SettingsGeneral from './scenes/SettingsGeneral/SettingsGeneral';
import SettingsIntegrations from './scenes/SettingsIntegrations';
import SettingsInvoices from './scenes/SettingsInvoices';
import SettingsMembers from './scenes/SettingsMembers';
import SettingsPayments from './scenes/SettingsPayments';
import SettingsStripe from './scenes/SettingsStripe';
import SettingsStripeTax from './scenes/SettingsStripeTax';

const tabs = [
  {
    name: 'General',
    href: '/settings/general',
    component: SettingsGeneral,
  },
  {
    name: 'Public details',
    href: '/settings/public-details',
    component: SettingsBusinessProfile,
  },
  {
    name: 'Team members',
    href: '/settings/members',
    component: SettingsMembers,
  },
  {
    name: 'Payments',
    href: '/settings/payments',
    component: SettingsPayments,
  },
  {
    name: 'Invoices',
    href: '/settings/invoices',
    component: SettingsInvoices,
  },
  {
    name: 'Domains',
    href: '/settings/domains',
    component: SettingsDomains,
  },
  {
    name: 'Email',
    href: '/settings/email',
    component: SettingsEmail,
  },
  {
    name: 'Customer portal',
    href: '/settings/customer-portal',
    component: SettingsCustomerPortal,
  },
  {
    name: 'Integrations',
    href: '/settings/integrations',
    component: SettingsIntegrations,
  },
  {
    name: 'Stripe Tax',
    href: '/settings/stripe-tax',
    component: SettingsStripeTax,
  },
  {
    name: 'Stripe & payouts',
    href: '/settings/stripe',
    component: SettingsStripe,
  },
];

const Settings = () => {
  return (
    <Card variant="root">
      <CardHeader variant="root">
        <CardHeaderTitle variant="root" className="w-full">
          Store settings
        </CardHeaderTitle>

        <CardHeaderNav.Container tabs={tabs}>
          {({ currentTab }) =>
            tabs.map(tab => (
              <CardHeaderNav.Tab key={tab.name} tab={tab} current={currentTab.href === tab.href}>
                {tab.name}
              </CardHeaderNav.Tab>
            ))
          }
        </CardHeaderNav.Container>
      </CardHeader>

      <CardContent variant="root" className="mt-4 mb-32">
        <Switch>
          {tabs.map(tab => (
            <Route key={tab.href} path={tab.href} component={tab.component} />
          ))}
        </Switch>
      </CardContent>
    </Card>
  );
};

export default Settings;
